/* unplugin-vue-components disabled */import script from "./TagPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TagPanel.vue?vue&type=style&index=0&id=39f302bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f302bb"]])

export default __exports__